import React, { useState, useEffect, useContext } from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"

import { getLinkPropsFromReference } from '../../utils/link'
import { RichLinks, RichContent } from '../../utils/html'

import PageMetaContext from '../../context/page-meta-context';

import { THEME_GREY } from '../../theme/theme'

import SectionContainer from '../section-container'

import { Inner, BlockContainer, BlockInner, Icon, Heading, Text, Buttons } from './contact-methods.styles'


const ContactMethods = ({items}) => {
	const meta = useContext(PageMetaContext);
	return (
		<ThemeProvider theme={(theme) => ({...theme,...THEME_GREY})}>
			<SectionContainer>
				<Inner>
					{items.map((item,index) => 
						<BlockContainer key={index} small={items.length === 3 || items.length > 4}>
							<BlockInner>
								{item.icon && <Icon src={item.icon.url} />}
								<Heading><RichContent render={item.heading} /></Heading>
								<Text><RichContent render={item.text} /></Text>
								<Buttons><RichLinks render={item.links} block="contact-methods" meta={meta} /></Buttons>
							</BlockInner>
						</BlockContainer>
					)}
				</Inner>
			</SectionContainer>
		</ThemeProvider>
	)
}

export default ContactMethods;